import styled from 'styled-components';

export const ShellContainer = styled.div`
  position: relative;
  display: block;
  width: 400px;
  height: 600px;
  box-shadow: 0 2px 3px #DDDDDD;
  border-collapse: collapse;
`;

export const ErrorContainer = styled.div`
  word-break: break-word;
  display: block;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const ErrorAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start
  padding: 30px;
`;

export const ErrorText = styled.div`
  text-align: center;
  font-size: x-large;
`;

export const ErrorDump = styled.div`
  overflow-y: auto;
  margin-top: 30px;
  height: 60%;
`;

export const LoaderContainer = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;